<template>
    <div class="placement-value mt-4 mb-2 flex justify-between font-oceanside">
        <span class="text-[16px] font-semibold text-ink"
            :class="{
                'text-red-error': hasErrorState,
            }"
        >
            {{label}}

            <span v-if="labelSecondary" class="text-[16px] font-normal">
                {{labelSecondary}}
            </span>

            <tooltip-button v-if="tooltip" :tooltip-text="tooltip" />
        </span>

        <span class="text-[16px] text-ink text-right">{{selectedLabel}}</span>
    </div>
</template>

<script>
    import TooltipButton from './buttons/TooltipButton.vue';

    export default {
        components: {
            TooltipButton,
        },
        props: {
            label: String,
            labelSecondary: String,
            tooltip: String,
            selectedLabel: String,
            hasErrorState: Boolean,
        },
    };
</script>
